import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

// All translations for the app
const translations = {
  nl: {
    // Header
    propertyListings: 'Woningaanbod',
    freeRentOut: 'Gratis woning verhuren',
    login: 'Inloggen',
    createAccount: 'Account maken',
    logout: 'Uitloggen',
    switchLanguage: 'Switch to English',
    subscribe: 'Nu abonneren',
    lookingForRoom: 'Ik zoek een kamer',
    findRoommate: 'Huisgenoot zoeken',
    cashbackDiscounts: 'Cashback en kortingen',
    myProfile: 'Mijn profiel',
    myListings: 'Mijn advertenties',
    myAccount: 'Mijn account',
    settings: 'Instellingen',
    howItWorks: 'Hoe werkt het?',
    aboutRoomHub: 'Over RoomHub',
    safety: 'Veiligheid',
    usefulTips: 'Handige tips',
    support: 'Support',
    
    // Homepage Hero
    heroRating: '4.8/5 uit 12.000+ reviews',
    heroTitle1: 'Vind direct',
    heroTitle2: 'jouw nieuwe thuis',
    heroSubtitle: '2.500+ kamers en appartementen beschikbaar in heel Nederland',
    
    // Search Form
    cityOrPostcode: 'Plaats of postcode',
    choosePropertyType: 'Kies woningtype',
    maxRent: 'max Huurprijs (€)',
    minSize: 'min Grootte (m²)',
    noMax: 'Geen max',
    noMin: 'Geen min',
    search: 'Zoeken',
    
    // Property Types
    room: 'Kamer',
    apartment: 'Appartement',
    studio: 'Studio',
    antiSquat: 'Anti-kraak',
    studentHousing: 'Studentenwoning',
    furnished: 'Gemeubileerd',
    temporary: 'Tijdelijk',
    longTerm: 'Lange Termijn',
    
    // Free Advertising Section
    freeAdvertisingTitle: 'Gratis adverteren en verhuren zonder kosten',
    freeAdvertisingDesc: 'Ben je op zoek naar een huurder? Zet je woning online en kom direct in contact met studenten, starters en expats.',
    placeAd: 'Advertentie plaatsen',
    readMoreRenting: 'Lees meer over verhuren',
    
    // Stats
    properties: 'Woningen',
    renters: 'Huurders',
    newPerDay: 'Per dag nieuw',
    rating: 'Rating',
    
    // Popular Cities
    findPropertiesInCities: 'Vind woningen in populaire steden',
    viewAllPropertiesNL: 'Bekijk alle woningen in Nederland',
    propertiesAvailable: 'woningen beschikbaar',
    
    // Featured Listings
    newlyAvailable: 'Nieuw beschikbaar',
    viewAll: 'Alles bekijken',
    perMonth: '/mnd',
    viewAllProperties: 'Bekijk alle woningen',
    
    // How It Works
    howDoesRoomHubWork: 'Hoe werkt RoomHub?',
    threeSimpleSteps: 'In 3 simpele stappen naar je nieuwe woning',
    step1Title: 'Zoek & Filter',
    step1Desc: 'Doorzoek duizenden woningen en filter op locatie, prijs en type',
    step2Title: 'Neem contact op',
    step2Desc: 'Stuur direct een bericht naar de verhuurder of huisgenoot',
    step3Title: 'Plan een bezichtiging',
    step3Desc: 'Maak een afspraak en vind je nieuwe thuis',
    
    // CTA
    readyToStart: 'Klaar om te beginnen?',
    createFreeAccount: 'Maak gratis een account en vind vandaag nog je nieuwe woning',
    freeRegister: 'Gratis registreren',
    viewOffer: 'Bekijk aanbod',
    
    // Footer
    forRenters: 'Voor huurders',
    searchProperties: 'Woningen zoeken',
    forLandlords: 'Voor verhuurders',
    rentOutProperty: 'Woning verhuren',
    pricing: 'Prijzen',
    company: 'Bedrijf',
    about: 'Over ons',
    contact: 'Contact',
    privacy: 'Privacy',
    terms: 'Voorwaarden',
    allRightsReserved: 'Alle rechten voorbehouden',
    
    // Listings Page
    listings: 'woningen',
    in: 'in',
    filters: 'Filters',
    location: 'Locatie',
    cityOrNeighborhood: 'Stad of wijk...',
    type: 'Type',
    allTypes: 'Alle types',
    maxPrice: 'Max prijs',
    minSizeFilter: 'Min grootte',
    onlyFurnished: 'Alleen gemeubileerd',
    clearFilters: 'Filters wissen',
    newest: 'Nieuwste',
    priceAsc: 'Prijs ↑',
    priceDesc: 'Prijs ↓',
    size: 'Grootte',
    noResults: 'Geen resultaten',
    tryOtherFilters: 'Probeer andere filters',
    verifiedLandlord: 'Geverifieerde verhuurder',
    
    // Auth Pages
    welcomeBack: 'Welkom terug',
    loginToAccount: 'Log in op je account',
    email: 'E-mailadres',
    password: 'Wachtwoord',
    forgotPassword: 'Je wachtwoord vergeten?',
    noAccount: 'Nog geen account?',
    registerHere: 'Registreer hier',
    createYourAccount: 'Maak je account aan',
    startFree: 'Start gratis en vind je nieuwe woning',
    fullName: 'Volledige naam',
    iAm: 'Ik ben een',
    renter: 'Huurder',
    landlord: 'Verhuurder',
    agreeToTerms: 'Door te registreren ga je akkoord met onze',
    termsOfService: 'Algemene voorwaarden',
    and: 'en',
    privacyPolicy: 'Privacybeleid',
    alreadyAccount: 'Heb je al een account?',
    loginHere: 'Log hier in',
    orContinueWith: 'Of ga verder met',
    continueWithGoogle: 'Doorgaan met Google',
    
    // Info Pages
    backToHome: 'Terug naar home',
    fourSimpleSteps: 'In 4 simpele stappen naar je nieuwe woning',
    step1InfoTitle: 'Maak een account',
    step1InfoDesc: 'Registreer gratis en maak je profiel compleet. Hoe meer informatie je deelt, hoe groter de kans dat verhuurders reageren.',
    step2InfoTitle: 'Zoek en filter',
    step2InfoDesc: 'Doorzoek duizenden woningen in heel Nederland. Filter op stad, prijs, grootte en type woning.',
    step3InfoTitle: 'Neem contact op',
    step3InfoDesc: 'Vond je een interessante woning? Stuur direct een bericht naar de verhuurder via ons platform.',
    step4InfoTitle: 'Plan een bezichtiging',
    step4InfoDesc: 'Maak een afspraak, bekijk de woning en teken het huurcontract. Welkom in je nieuwe thuis!',
    
    aboutRoomHubTitle: 'Over RoomHub',
    aboutRoomHubSubtitle: 'Het grootste platform voor kamers en appartementen in Nederland',
    
    safetyTitle: 'Veiligheid',
    safetySubtitle: 'Jouw veiligheid is onze prioriteit',
    
    tipsTitle: 'Handige Tips',
    tipsSubtitle: 'Vergroot je kans op een woning met deze tips',
    
    supportTitle: 'Support',
    supportSubtitle: 'We helpen je graag',
    
    // Premium Page
    premiumTitle: 'Word Premium',
    premiumSubtitle: 'Vergroot je kansen en vind sneller je droomwoning',
    mostChosen: 'Meest gekozen',
    weeks: 'weken',
    months: 'maanden',
    save: 'Bespaar',
    choosePlan: 'Kies dit plan',
    
    // Dashboard
    dashboard: 'Dashboard',
    messages: 'Berichten',
    favorites: 'Favorieten',
    reactions: 'Reacties',
    
    // Admin
    adminDashboard: 'Admin Dashboard',
    manageAndApprove: 'Beheer en keur advertenties goed',
    waiting: 'Wachtend',
    approved: 'Goedgekeurd',
    rejected: 'Afgewezen',
    totalOnline: 'Totaal online',
    users: 'Gebruikers',
    waitingForApproval: 'Wachtend op goedkeuring',
    noListingsWaiting: 'Geen advertenties wachtend',
    allReviewed: 'Alle advertenties zijn beoordeeld',
    selectListing: 'Selecteer een advertentie',
    clickToView: 'Klik op een advertentie om de details te bekijken',
    description: 'Beschrijving',
    landlordInfo: 'Verhuurder informatie',
    rejectionReason: 'Reden voor afwijzing (verplicht bij afwijzen)',
    rejectionPlaceholder: 'Bijv. Onduidelijke foto\'s, ontbrekende informatie, verdachte prijs...',
    approve: 'Goedkeuren',
    reject: 'Afwijzen',
    noAccess: 'Geen toegang',
    noAdminRights: 'Je hebt geen admin rechten om deze pagina te bekijken.',
    
    // Profile Page
    profile: 'Profiel',
    yourProfile: 'Jouw Profiel',
    editProfile: 'Profiel Bewerken',
    saveChanges: 'Opslaan',
    cancel: 'Annuleren',
    yourPreferences: 'Jouw Voorkeuren',
    profileType: 'Profiel Type',
    cities: 'Steden',
    propertyTypes: 'Woningtypes',
    budget: 'Budget',
    min: 'Min',
    max: 'Max',
    notifications: 'Meldingen',
    emailNotificationsOn: 'E-mail meldingen aan',
    emailNotificationsOff: 'E-mail meldingen uit',
    subscription: 'Abonnement',
    premiumActive: 'Premium Actief',
    freeAccount: 'Gratis Account',
    upgradeToPremium: 'Upgrade naar Premium',
    cancelSubscription: 'Opzeggen',
    confirmCancel: 'Bevestig Opzegging',
    keepSubscription: 'Behouden',
    cancelWarning: 'Weet je zeker dat je wilt opzeggen? Je verliest toegang tot onbeperkt swipen.',
    avatar: 'Avatar',
    chooseAvatar: 'Kies Avatar',
    selectYourStyle: 'Selecteer je stijl',
    
    // Verhuurder Dashboard
    landlordDashboard: 'Verhuurder Dashboard',
    myProperties: 'Mijn Woningen',
    interestedRenters: 'Geïnteresseerde Huurders',
    addNewProperty: 'Nieuwe Woning Toevoegen',
    viewInterested: 'Bekijk Geïnteresseerden',
    editProperty: 'Woning Bewerken',
    pauseProperty: 'Pauzeren',
    activateProperty: 'Activeren',
    deleteProperty: 'Verwijderen',
    views: 'Views',
    interests: 'Interesse',
    active: 'Actief',
    paused: 'Gepauzeerd',
    noProperties: 'Nog Geen Woningen',
    noPropertiesDesc: 'Voeg je eerste woning toe om interesse van huurders te ontvangen.',
    addFirstProperty: 'Eerste Woning Toevoegen',
    tenantPreferences: 'Huurdersvoorkeuren',
    preferredTenants: 'Gewenste Huurders',
    editPreferences: 'Voorkeuren Bewerken',
    
    // SwipeMatch Page
    whoAreYou: 'Wie ben jij?',
    selectProfileType: 'Selecteer je profiel type',
    student: 'Student',
    starter: 'Starter',
    professional: 'Professional',
    expat: 'Expat',
    couple: 'Koppel',
    family: 'Gezin',
    whereDoYouWant: 'Waar wil je wonen?',
    selectCities: 'Selecteer één of meer steden',
    popularCities: 'Populair',
    whatKindOfHome: 'Wat voor woning?',
    selectPropertyTypes: 'Selecteer woningtypes',
    whatIsYourBudget: 'Wat is je budget?',
    setBudgetRange: 'Stel je prijsrange in',
    yourIntroduction: 'Jouw Introductie',
    writeIntroduction: 'Schrijf je introductie voor verhuurders',
    nextStep: 'Volgende',
    previousStep: 'Vorige',
    startSwiping: 'Start Swipen',
    
    // Swipe Interface
    swipesRemaining: 'swipes over',
    noMoreProperties: 'Geen woningen meer',
    youveSeenAll: 'Je hebt alle beschikbare woningen gezien die aan je voorkeuren voldoen.',
    updatePreferences: 'Voorkeuren Aanpassen',
    orUpgrade: 'Of upgrade naar Premium voor onbeperkt swipen',
    like: 'Like',
    nope: 'Nee',
    info: 'Info',
    back: 'Terug',
    messageSent: 'Bericht verstuurd!',
    messageSentDesc: 'De verhuurder heeft je introductie ontvangen.',
    skipped: 'Overgeslagen',
    
    // Premium Page
    unlimitedSwipes: 'Onbeperkt Swipen',
    prioritySupport: 'Prioriteit Support',
    advancedFilters: 'Geavanceerde Filters',
    noAds: 'Geen Advertenties',
    freeTrialDays: '7 Dagen Gratis Proberen',
    thenPerMonth: 'daarna €4,99/week',
    startFreeTrial: 'Start Gratis Proefperiode',
    alreadyPremium: 'Je bent al Premium!',
    enjoyUnlimitedAccess: 'Geniet van onbeperkte toegang tot alle woningen.',
    
    // Rental Preferences
    rentalDuration: 'Huurduur',
    shortTerm: '1-3 maanden',
    mediumTerm3_6: '3-6 maanden',
    mediumTerm6_12: '6-12 maanden',
    longTerm1Year: '1+ jaar',
    flexible: 'Flexibel',
    indefinite: 'Onbepaald',
    anyDuration: 'Elke duur',
    numberOfPersons: 'Aantal Personen',
    person: 'persoon',
    persons: 'personen',
    havePets: 'Heb je huisdieren?',
    yes: 'Ja',
    no: 'Nee',
    needRegistration: 'Heb je inschrijving nodig?',
    petsAllowed: 'Huisdieren toegestaan',
    registrationPossible: 'Inschrijving mogelijk',
    maxTenants: 'Max huurders',
    minRentalPeriod: 'Min huurperiode',
  },
  en: {
    // Header
    propertyListings: 'Property Listings',
    freeRentOut: 'List property free',
    login: 'Login',
    createAccount: 'Create account',
    logout: 'Logout',
    switchLanguage: 'Schakel naar Nederlands',
    subscribe: 'Subscribe now',
    lookingForRoom: 'I\'m looking for a room',
    findRoommate: 'Find roommate',
    cashbackDiscounts: 'Cashback & discounts',
    myProfile: 'My profile',
    myListings: 'My listings',
    myAccount: 'My account',
    settings: 'Settings',
    howItWorks: 'How does it work?',
    aboutRoomHub: 'About RoomHub',
    safety: 'Safety',
    usefulTips: 'Useful tips',
    support: 'Support',
    
    // Homepage Hero
    heroRating: '4.8/5 from 12,000+ reviews',
    heroTitle1: 'Find',
    heroTitle2: 'your new home',
    heroSubtitle: '2,500+ rooms and apartments available throughout the Netherlands',
    
    // Search Form
    cityOrPostcode: 'City or postcode',
    choosePropertyType: 'Choose property type',
    maxRent: 'max Rent (€)',
    minSize: 'min Size (m²)',
    noMax: 'No max',
    noMin: 'No min',
    search: 'Search',
    
    // Property Types
    room: 'Room',
    apartment: 'Apartment',
    studio: 'Studio',
    antiSquat: 'Anti-squat',
    studentHousing: 'Student housing',
    furnished: 'Furnished',
    temporary: 'Temporary',
    longTerm: 'Long term',
    
    // Free Advertising Section
    freeAdvertisingTitle: 'Free advertising and renting without costs',
    freeAdvertisingDesc: 'Looking for a tenant? Put your property online and connect directly with students, starters and expats.',
    placeAd: 'Place advertisement',
    readMoreRenting: 'Read more about renting',
    
    // Stats
    properties: 'Properties',
    renters: 'Renters',
    newPerDay: 'New per day',
    rating: 'Rating',
    
    // Popular Cities
    findPropertiesInCities: 'Find properties in popular cities',
    viewAllPropertiesNL: 'View all properties in the Netherlands',
    propertiesAvailable: 'properties available',
    
    // Featured Listings
    newlyAvailable: 'Newly available',
    viewAll: 'View all',
    perMonth: '/mo',
    viewAllProperties: 'View all properties',
    
    // How It Works
    howDoesRoomHubWork: 'How does RoomHub work?',
    threeSimpleSteps: 'Find your new home in 3 simple steps',
    step1Title: 'Search & Filter',
    step1Desc: 'Browse thousands of properties and filter by location, price and type',
    step2Title: 'Get in touch',
    step2Desc: 'Send a message directly to the landlord or roommate',
    step3Title: 'Schedule a viewing',
    step3Desc: 'Make an appointment and find your new home',
    
    // CTA
    readyToStart: 'Ready to start?',
    createFreeAccount: 'Create a free account and find your new home today',
    freeRegister: 'Register for free',
    viewOffer: 'View listings',
    
    // Footer
    forRenters: 'For renters',
    searchProperties: 'Search properties',
    forLandlords: 'For landlords',
    rentOutProperty: 'Rent out property',
    pricing: 'Pricing',
    company: 'Company',
    about: 'About us',
    contact: 'Contact',
    privacy: 'Privacy',
    terms: 'Terms',
    allRightsReserved: 'All rights reserved',
    
    // Listings Page
    listings: 'properties',
    in: 'in',
    filters: 'Filters',
    location: 'Location',
    cityOrNeighborhood: 'City or neighborhood...',
    type: 'Type',
    allTypes: 'All types',
    maxPrice: 'Max price',
    minSizeFilter: 'Min size',
    onlyFurnished: 'Only furnished',
    clearFilters: 'Clear filters',
    newest: 'Newest',
    priceAsc: 'Price ↑',
    priceDesc: 'Price ↓',
    size: 'Size',
    noResults: 'No results',
    tryOtherFilters: 'Try different filters',
    verifiedLandlord: 'Verified landlord',
    
    // Auth Pages
    welcomeBack: 'Welcome back',
    loginToAccount: 'Log in to your account',
    email: 'Email address',
    password: 'Password',
    forgotPassword: 'Forgot your password?',
    noAccount: 'Don\'t have an account yet?',
    registerHere: 'Register here',
    createYourAccount: 'Create your account',
    startFree: 'Start free and find your new home',
    fullName: 'Full name',
    iAm: 'I am a',
    renter: 'Renter',
    landlord: 'Landlord',
    agreeToTerms: 'By registering you agree to our',
    termsOfService: 'Terms of Service',
    and: 'and',
    privacyPolicy: 'Privacy Policy',
    alreadyAccount: 'Already have an account?',
    loginHere: 'Log in here',
    orContinueWith: 'Or continue with',
    continueWithGoogle: 'Continue with Google',
    
    // Info Pages
    backToHome: 'Back to home',
    fourSimpleSteps: 'Find your new home in 4 simple steps',
    step1InfoTitle: 'Create an account',
    step1InfoDesc: 'Register for free and complete your profile. The more information you share, the better your chances that landlords will respond.',
    step2InfoTitle: 'Search and filter',
    step2InfoDesc: 'Browse thousands of properties throughout the Netherlands. Filter by city, price, size and property type.',
    step3InfoTitle: 'Get in touch',
    step3InfoDesc: 'Found an interesting property? Send a message directly to the landlord through our platform.',
    step4InfoTitle: 'Schedule a viewing',
    step4InfoDesc: 'Make an appointment, view the property and sign the lease. Welcome to your new home!',
    
    aboutRoomHubTitle: 'About RoomHub',
    aboutRoomHubSubtitle: 'The largest platform for rooms and apartments in the Netherlands',
    
    safetyTitle: 'Safety',
    safetySubtitle: 'Your safety is our priority',
    
    tipsTitle: 'Useful Tips',
    tipsSubtitle: 'Increase your chances of finding a property with these tips',
    
    supportTitle: 'Support',
    supportSubtitle: 'We\'re happy to help',
    
    // Premium Page
    premiumTitle: 'Go Premium',
    premiumSubtitle: 'Increase your chances and find your dream home faster',
    mostChosen: 'Most popular',
    weeks: 'weeks',
    months: 'months',
    save: 'Save',
    choosePlan: 'Choose this plan',
    
    // Dashboard
    dashboard: 'Dashboard',
    messages: 'Messages',
    favorites: 'Favorites',
    reactions: 'Reactions',
    
    // Admin
    adminDashboard: 'Admin Dashboard',
    manageAndApprove: 'Manage and approve listings',
    waiting: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    totalOnline: 'Total online',
    users: 'Users',
    waitingForApproval: 'Waiting for approval',
    noListingsWaiting: 'No listings waiting',
    allReviewed: 'All listings have been reviewed',
    selectListing: 'Select a listing',
    clickToView: 'Click on a listing to view details',
    description: 'Description',
    landlordInfo: 'Landlord information',
    rejectionReason: 'Reason for rejection (required when rejecting)',
    rejectionPlaceholder: 'E.g. Unclear photos, missing information, suspicious price...',
    approve: 'Approve',
    reject: 'Reject',
    noAccess: 'No access',
    noAdminRights: 'You don\'t have admin rights to view this page.',
    
    // Profile Page
    profile: 'Profile',
    yourProfile: 'Your Profile',
    editProfile: 'Edit Profile',
    saveChanges: 'Save Changes',
    cancel: 'Cancel',
    yourPreferences: 'Your Preferences',
    profileType: 'Profile Type',
    cities: 'Cities',
    propertyTypes: 'Property Types',
    budget: 'Budget',
    min: 'Min',
    max: 'Max',
    notifications: 'Notifications',
    emailNotificationsOn: 'Email notifications on',
    emailNotificationsOff: 'Email notifications off',
    subscription: 'Subscription',
    premiumActive: 'Premium Active',
    freeAccount: 'Free Account',
    upgradeToPremium: 'Upgrade to Premium',
    cancelSubscription: 'Cancel Subscription',
    confirmCancel: 'Confirm Cancellation',
    keepSubscription: 'Keep Subscription',
    cancelWarning: 'Are you sure you want to cancel? You will lose access to unlimited swipes.',
    avatar: 'Avatar',
    chooseAvatar: 'Choose Avatar',
    selectYourStyle: 'Select your style',
    
    // Verhuurder Dashboard
    landlordDashboard: 'Landlord Dashboard',
    myProperties: 'My Properties',
    interestedRenters: 'Interested Renters',
    addNewProperty: 'Add New Property',
    viewInterested: 'View Interested',
    editProperty: 'Edit Property',
    pauseProperty: 'Pause Property',
    activateProperty: 'Activate Property',
    deleteProperty: 'Delete Property',
    views: 'Views',
    interests: 'Interests',
    active: 'Active',
    paused: 'Paused',
    noProperties: 'No Properties Yet',
    noPropertiesDesc: 'Add your first property to start receiving interest from renters.',
    addFirstProperty: 'Add First Property',
    tenantPreferences: 'Tenant Preferences',
    preferredTenants: 'Preferred Tenants',
    editPreferences: 'Edit Preferences',
    
    // SwipeMatch Page
    whoAreYou: 'Who are you?',
    selectProfileType: 'Select your profile type',
    student: 'Student',
    starter: 'Starter',
    professional: 'Professional',
    expat: 'Expat',
    couple: 'Couple',
    family: 'Family',
    whereDoYouWant: 'Where do you want to live?',
    selectCities: 'Select one or more cities',
    popularCities: 'Popular',
    whatKindOfHome: 'What kind of home?',
    selectPropertyTypes: 'Select property types',
    whatIsYourBudget: 'What is your budget?',
    setBudgetRange: 'Set your price range',
    yourIntroduction: 'Your Introduction',
    writeIntroduction: 'Write your introduction for landlords',
    nextStep: 'Next Step',
    previousStep: 'Previous',
    startSwiping: 'Start Swiping',
    
    // Swipe Interface
    swipesRemaining: 'swipes remaining',
    noMoreProperties: 'No more properties',
    youveSeenAll: 'You\'ve seen all available properties matching your preferences.',
    updatePreferences: 'Update Preferences',
    orUpgrade: 'Or upgrade to Premium for unlimited swipes',
    like: 'Like',
    nope: 'Nope',
    info: 'Info',
    back: 'Back',
    messageSent: 'Message sent!',
    messageSentDesc: 'The landlord has received your introduction.',
    skipped: 'Skipped',
    
    // Premium Page
    unlimitedSwipes: 'Unlimited Swipes',
    prioritySupport: 'Priority Support',
    advancedFilters: 'Advanced Filters',
    noAds: 'No Advertisements',
    freeTrialDays: '7 Day Free Trial',
    thenPerMonth: 'then €4.99/week',
    startFreeTrial: 'Start Free Trial',
    alreadyPremium: 'You\'re already Premium!',
    enjoyUnlimitedAccess: 'Enjoy unlimited access to all properties.',
    
    // Rental Preferences
    rentalDuration: 'Rental Duration',
    shortTerm: '1-3 months',
    mediumTerm3_6: '3-6 months',
    mediumTerm6_12: '6-12 months',
    longTerm1Year: '1+ year',
    flexible: 'Flexible',
    indefinite: 'Indefinite',
    anyDuration: 'Any duration',
    numberOfPersons: 'Number of Persons',
    person: 'person',
    persons: 'persons',
    havePets: 'Do you have pets?',
    yes: 'Yes',
    no: 'No',
    needRegistration: 'Do you need municipal registration?',
    petsAllowed: 'Pets allowed',
    registrationPossible: 'Registration possible',
    maxTenants: 'Max tenants',
    minRentalPeriod: 'Min rental period',
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('roomhub_language');
    return saved || 'nl';
  });

  useEffect(() => {
    localStorage.setItem('roomhub_language', language);
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'nl' ? 'en' : 'nl');
  };

  const t = (key) => {
    return translations[language][key] || key;
  };

  // Get property type label based on language
  const getTypeLabel = (typeId) => {
    const typeMap = {
      kamer: language === 'nl' ? 'Kamer' : 'Room',
      appartement: language === 'nl' ? 'Appartement' : 'Apartment',
      studio: 'Studio',
      antikraak: language === 'nl' ? 'Anti-kraak' : 'Anti-squat',
      studentenwoning: language === 'nl' ? 'Studentenwoning' : 'Student housing',
      gemeubileerd: language === 'nl' ? 'Gemeubileerd' : 'Furnished',
      tijdelijk: language === 'nl' ? 'Tijdelijk' : 'Temporary',
      langetermijn: language === 'nl' ? 'Lange Termijn' : 'Long term',
    };
    return typeMap[typeId] || typeId;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t, getTypeLabel }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
